module.exports = __webpack_public_path__ + "img/chr_ts_mob.5381a042.png";